import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { GET_ALL_SERVICE_TASKS_OF_A_SERVICE, GET_TASK_BY_ID, GET_TASKS } from '../graphql/queries/tasks.query';
import {
  CREATE_TASK,
  REMOVE_TASK,
  REMOVE_TASK_LIST_ITEM,
  REMOVE_TASK_VARIANT_ITEM,
  UPDATE_TASK,
} from '../graphql/mutation/tasks.mutation';

@Injectable({
  providedIn: 'root',
})
export class TasksService {
  constructor(private apollo: Apollo) {}

  fetchTaskById(id: any): Observable<any> {
    return this.apollo
      .use('project')
      .watchQuery<any>({
        query: GET_TASK_BY_ID,
        variables: { id },
        fetchPolicy: 'network-only',
      })
      .valueChanges.pipe(map((result) => result.data?.task || []));
      
  }

  findAllServiceTasksOfAService(serviceId: any): Observable<any> {
    return this.apollo
      .use('project')
      .watchQuery<any>({
        query: GET_ALL_SERVICE_TASKS_OF_A_SERVICE,
        variables: { serviceId },
        fetchPolicy: 'network-only',
      })
      .valueChanges.pipe(map((result) => result.data?.findAllServiceTasksOfAService || []));
      
  }
  fetchTasks(search: string = ''): Observable<any> {
    return this.apollo
      .use('project')
      .watchQuery<any>({
        query: GET_TASKS,
        variables: { search },
        fetchPolicy: 'network-only',
      })
      .valueChanges.pipe(map((result) => result.data?.tasks || []));
      
  }

  createTask(createTaskInput: any, taskCheckListItems: any, taskVariants: any): Observable<any> {
    return this.apollo.use('project').mutate({
      mutation: CREATE_TASK,
      variables: {
        createTaskInput,
        taskCheckListItems,
        taskVariants
      },
    });
  }

  updateTask(updateTaskInput: any, taskCheckListItems: any, taskVariants: any): Observable<any> {
    return this.apollo.use('project').mutate({
      mutation: UPDATE_TASK,
      variables: {
        updateTaskInput,
        taskCheckListItems,
        taskVariants
      },
    });
  }

  removeTask(id: number): Observable<any> {
    return this.apollo.use('project').mutate({
      mutation: REMOVE_TASK,
      variables: { id },
    });
  }

  removeTaskCheckListItem(id: number): Observable<any> {
    return this.apollo.use('project').mutate({
      mutation: REMOVE_TASK_LIST_ITEM,
      variables: { id },
    });
  }

  removeTaskVariantItem(id: number): Observable<any> {
    return this.apollo.use('project').mutate({
      mutation: REMOVE_TASK_VARIANT_ITEM,
      variables: { id },
    });
  }
}
